import { render, staticRenderFns } from "./ConsultationControlModal.vue?vue&type=template&id=23fe1791"
import script from "./ConsultationControlModal.vue?vue&type=script&lang=js"
export * from "./ConsultationControlModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports